import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SupplyBillItemsAllList from './SupplyBillItemsAllList'
import SupplyBillItemsAllFilters from './filters/SupplyBillItemsAllFilters'

const SupplyBillItemsAll = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Позиції по всім рахункам'}
            // isBack={true}
            // options={
            //     <SupplyOrderOptions />
            // }
        />
		<MyBlock>
            <SupplyBillItemsAllFilters />
        </MyBlock>
		<MyBlock>
			<SupplyBillItemsAllList />
		</MyBlock>
    </LayoutMain>
  )
}

export default SupplyBillItemsAll